// @flow
import React from 'react';
import { SplashStyles as styles } from './styles';

const Splash = () => (
  <>
    <div id="splash_preload" />
    <p style={styles.label}>Ready to Cast</p>
  </>
);
/* NOTE: <div id="splash_preload" /> uses global styles defined in src/App.css */

export { Splash };
